import React from 'react';

import Button from 'js/components/button';
import WorkflowPanel from 'js/components/workflow_panel';

import './index.scss';

export default function NoMissedGuidelinesApproveOrDoNotDistribute({
    onPrevious,
    onApprove,
    onDoNotDistribute,
    isTransmitting
}) {
    const buttons = [
        onPrevious ? (
            <Button back ghost key="previous" onClick={onPrevious} disabled={isTransmitting}>
                Prev
            </Button>
        ) : null,
        <Button primary key="approve" onClick={onApprove} disabled={isTransmitting}>
            Approve To Post
        </Button>,
        <Button
            caution
            key="do-not-distribute"
            onClick={onDoNotDistribute}
            disabled={isTransmitting}
            style={{backgroundColor: '#F8B543'}}
        >
            Approve & Do Not Post
        </Button>
    ];
    return (
        <WorkflowPanel
            className="no-missed-guidelines-approve-or-do-not-distribute"
            buttons={buttons}
        >
            <div className="no-missed-guidelines-approve-or-do-not-distribute__image" />
            <div className="no-missed-guidelines-approve-or-do-not-distribute__heading">
                Hooray, No Missed Guidelines!
            </div>
            <div className="no-missed-guidelines-approve-or-do-not-distribute__subheading">
                Please Approve or Deny this content for distribution
            </div>
        </WorkflowPanel>
    );
}



// WEBPACK FOOTER //
// ./components/no_missed_guidelines_approve_or_do_not_distribute/index.js